import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { registerSupplierRequest, registerSupplierRequestError, registerSupplierRequestSuccess } from "../../slices/Supplier/RegisterSupplierSlice";

export const RegisterSupplierAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(registerSupplierRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.registerSupplier,
                data: data,
            })
            return dispatch(registerSupplierRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(registerSupplierRequestError(_error));
        }
    };
};
